module.exports = __webpack_public_path__ + "img/llot-logo.7fdfbaea.svg";